import type { TWidget } from 'widgets/Widget';

/**
 * @description ChangeStoreSelectorBtn implementation
 * @param Widget Base widget for extending
 * @returns Product change store selector btn widget
 */
function ChangeStoreSelectorBtnClassCreator(Widget: TWidget) {
    /**
     * @category widgets
     * @subcategory product
     * @class ChangeStoreSelectorBtn
     * @classdesc Represents a button that triggers the store selector overlay.
     * @example <caption>Change Store Selector Button HTML Structure</caption>
     * <div
     *  class="b-product_delivery_option"
     *  data-widget="changeStoreSelectorBtn"
     *  data-header-text="header text"
     *  data-pid="${pid}"
     *  data-is-show-store-selector="${true}"
     *  data-store-selector-url="${URLUtils.url('Bopis-StoreSelectorOverlayShow')}"
     * >
     *  <button class="b-button m-link"
     *   data-widget="processButton"
     *   data-event-click.prevent="handleClick"
     *   data-widget-event-click="showStoreSelector"
     *  >
     *   ${Resource.msg('bopis.change.store', 'product', null)}
     *  </button>
     * </div>
     */

    class ChangeStoreSelectorBtn extends Widget {
        prefs() {
            return {
                pid: '',
                isShowStoreSelector: false,
                storeSelectorUrl: '',
                headerText: '',
                ...super.prefs()
            };
        }

        /**
         * @description Shows the store selector overlay by emitting a 'drawershow' event.
         */
        showStoreSelector(): void {
            if (!this.prefs().isShowStoreSelector) {
                return;
            }

            this.eventBus().emit('drawershow', {
                url: `${this.prefs().storeSelectorUrl}?pid=${this.prefs().pid}`,
                headerText: this.prefs().headerText,
                ariaLabel: this.prefs().headerText,
                bodyClass: 'm-has_dialog',
                wrapperClasses: 'm-bopis_overlay'
            });
        }
    }

    return ChangeStoreSelectorBtn;
}

export type TChangeStoreSelectorBtn = ReturnType<typeof ChangeStoreSelectorBtnClassCreator>;

export type TChangeStoreSelectorBtnInstance = InstanceType<TChangeStoreSelectorBtn>;

export default ChangeStoreSelectorBtnClassCreator;
